import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dockets: [],
  docketById: {},
  isDocketCreating: false,
};

const docketSlice = createSlice({
  name: "docket",
  initialState,
  reducers: {
    getAllDockets: (state, action) => {
      state.dockets = action.payload.dockets;
    },
    getDocketById: (state, action) => {
      state.docketById = action.payload.docketById;
    },
    setDocketIsCreating(state, action) {
      state.isDocketCreating = action.payload.isDocketCreating;
    },
  },
});

export const { getAllDockets, getDocketById, setDocketIsCreating } =
  docketSlice.actions;
export const docketReducer = docketSlice.reducer;
